@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>
          @if (column.keyColumn == 'select') {
            <mat-checkbox
              [checked]="allSelected"
              [indeterminate]="someSelected"
              (change)="toggleSelectAllEvent($event.checked)"
            />
          } @else {
            {{ column.description }}
          }
        </th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'select') {
            <mat-checkbox
              [checked]="selectedIds.includes(element[selectionIdField])"
              (change)="toggleSelectItemEvent(element)"
            />
          } @else if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              <mat-icon
                *ngIf="column.key.edit"
                class="btn-icon-outline"
                fontIcon="edit"
                matTooltip="Editar"
                (click)="editItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.copyLink"
                class="btn-icon-outline"
                fontIcon="link"
                matTooltip="Copiar link"
                (click)="copyLinkItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.sendEmail"
                class="btn-icon-outline"
                fontIcon="email"
                matTooltip="Enviar e-mail"
                (click)="sendEmailItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.sendToFleet"
                class="btn-icon-outline"
                fontIcon="swap_horiz"
                matTooltip="Enviar para Frota"
                (click)="sendToFleetEvent(element)"
              />
            </div>
          } @else if (column.keyColumn == 'os_info') {
            <b>OS: </b>{{ element.codigoOs }}<br />
            <b>TG: </b>{{ element.codigoTg }}
          } @else if (column.keyColumn == 'period') {
            <b>Inicio:</b> {{ element.dataInicio }}
            {{ formatTime(element.horaInicio) }}<br />
            <b>Fim:</b> {{ element.dataFinal }}
            {{ formatTime(element.horaFinal) }}
          } @else if (column.keyColumn == 'trecho') {
            {{ element.descricaoOrigem
            }}@if (element.estadoOrigem) {
              ({{ element.estadoOrigem }})
            }
            →
            {{ element.descricaoDestino
            }}@if (element.estadoDestino) {
              ({{ element.estadoDestino }})
            }
          } @else if (column.keyColumn == 'pax') {
            {{ element.pax ?? element.quantidadePassageiros ?? '-' }}
          } @else if (column.keyColumn == 'servico_info') {
            <b>Tipo Serviço: </b>{{ element.descricaoTipoServico ?? '-' }}<br />
            <b>Serviço: </b>{{ element.servico ?? '-' }}<br />
            <b>Veículo: </b>{{ element.descricaoTipoVeiculo ?? '-' }}<br />
            <b>Motorista: </b>{{ element.descricaoTipoMotorista ?? '-' }}
          } @else if (column.keyColumn == 'status_info') {
            {{ element.descricaoStatusOs ?? element.descricaoStatus }}
            @if (element.isPendente == 'S') {
              <br />Pendente
            }
          } @else if (column.keyColumn == 'fornecedor') {
            {{ element.nomeFornecedor ?? '—' }}
          } @else if (column.keyColumn == 'consultores') {
            <b>Operacional: </b>{{ element.nomeConsultorOperacional ?? '-' }}<br />
            <b>Compras: </b>{{ element.nomeFornecedorAtribuidoPor ?? '-' }}
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
